module.exports = __webpack_public_path__ + "04_medium_gold.f942e18b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer5/04_medium_gold.png
// module id = IvoO
// module chunks = 0